import React from 'react';
import { Link } from 'react-router-dom';
import { ProgramCard } from '../../components/ProgramCard';
import { ArrowRight } from 'lucide-react';
export function HomePrograms() {
  return <section className="py-24 bg-off-white" data-id="element-1747">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1748">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1749">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-1750">
            Storm Taekwondo Classes & Programs
          </h2>
          <p className="text-xl text-gray-warm" data-id="element-1751">
            From first-time kids to adults, families, competitors, and summer
            camp students, Storm has a class or program designed to help each
            student grow.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1752">
          <ProgramCard title="Mini Troopers Program" ageRange="Ages 3-5" whoItsFor="A structured intro to taekwondo for younger kids. Students practice listening, balance, confidence, focus, and beginner martial arts basics." imageUrl="https://drwzpk38qkpfb.cloudfront.net/www.stormtaekwondo.com/uploaded/images/Redesigne%202024/Mini-Troopers-Storm-Taekwondo.jpg" href="/mini-troopers" data-id="element-1753" />
          <ProgramCard title="Kids Taekwondo Classes" ageRange="Ages 6+" whoItsFor="Our core kids classes help students build confidence, discipline, fitness, respect, and taekwondo skills in a high-energy program setting." imageUrl="https://drwzpk38qkpfb.cloudfront.net/www.stormtaekwondo.com/uploaded/images/Redesigne%202024/Discover%20the%20Perfect%20Program%20for%20Your%20Mini%20Trooper.png" href="/kids-taekwondo-classes-in-farmington-hills-michigan" data-id="element-1754" />
          <ProgramCard title="Adult Taekwondo Classes" ageRange="Adults" whoItsFor="Beginner-friendly adult martial arts classes focused on fitness, confidence, discipline, and real taekwondo skill development." imageUrl="https://cdn.magicpatterns.com/uploads/t7AgirMmJivJBXyaULHJUS/Adult.png" href="/karate-adult-classes" data-id="element-1755" />
        </div>

        <div className="mt-16 flex justify-center" data-id="element-1756">
          <Link to="/Programs.html" className="btn-primary inline-flex items-center gap-2" data-id="element-1757">
            View Classes & Programs
            <ArrowRight className="w-5 h-5" data-id="element-1758" />
          </Link>
        </div>
      </div>
    </section>;
}